import React from "react";
import { Button, makeStyles, Popover, PopoverSurface, PopoverTrigger } from "@fluentui/react-components";
import PropTypes from "prop-types";
import { ReactComponent as EnterOnVR } from "../icons/EnterOnVR.svg";
import { Dismiss20Regular } from "@fluentui/react-icons";

const useStyles = makeStyles({
  root: {
    height: "40px",
    minWidth: "40px",
    backgroundColor: "rgba(22, 24, 30, 0.60)",
    "@media (min-width: 992px)": {
      position: "fixed",
      bottom: "20px",
      right: "30px"
    },
    "& span": {
      width: "24px",
      height: "24px",
      fontSize: "24px"
    },
    "& svg": {
      color: "#fff",
      fill: "#fff"
    }
  },
  // Width 200px on mobile, 300px on desktop
  enterOnVRPopover: {
    width: "200px",
    "@media (min-width: 992px)": {
      width: "300px"
    }
  }
});

export function EnterOnVRPopover({ children, open, onOpen, onClose }) {
  const classes = useStyles();

  const handleOpenChange = (_, { open }) => {
    open ? onOpen() : onClose();
  };

  return (
    <Popover open={open} positioning={"above-start"} withArrow onOpenChange={handleOpenChange}>
      <PopoverTrigger disableButtonEnhancement>
        <Button className={classes.root} appearance="subtle" icon={<EnterOnVR />} />
      </PopoverTrigger>
      <PopoverSurface tabIndex={-1}>
        <div style={{ display: "flex", width: "100%", justifyContent: "flex-end" }}>
          <Button style={{ maxHeight: "32px" }} appearance="subtle" icon={<Dismiss20Regular />} onClick={onClose} />
        </div>
        <div className={classes.enterOnVRPopover}>{children}</div>
      </PopoverSurface>
    </Popover>
  );
}

EnterOnVRPopover.propTypes = {
  children: PropTypes.node,
  open: PropTypes.bool,
  onOpen: PropTypes.func,
  onClose: PropTypes.func
};
